import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import {
  ArrowBack as BackIcon,
  Edit as EditIcon,
  Publish as PublishIcon,
  Unpublished as UnpublishIcon,
} from '@mui/icons-material';
import { QuizWithQuestions } from '../../../types/quiz';

interface QuizHeaderProps {
  quiz: QuizWithQuestions | null;
  onBack: () => void;
  onEditDetails: () => void;
  onTogglePublish: () => void;
}

/**
 * Header component for Quiz Builder
 * Shows title, description, and action buttons (edit, publish/unpublish)
 */
const QuizHeader: React.FC<QuizHeaderProps> = ({
  quiz,
  onBack,
  onEditDetails,
  onTogglePublish,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Button
        startIcon={<BackIcon />}
        onClick={onBack}
        sx={{ mb: 2 }}
      >
        Back to Quizzes
      </Button>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
            {quiz ? quiz.title : 'Create New Quiz'}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {quiz ? 'Edit quiz details and manage questions' : 'Set up your quiz details'}
          </Typography>
        </Box>

        {quiz && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={onEditDetails}
            >
              Edit Details
            </Button>
            <Button
              variant="contained"
              color={quiz.isPublished ? 'warning' : 'success'}
              startIcon={quiz.isPublished ? <UnpublishIcon /> : <PublishIcon />}
              onClick={onTogglePublish}
            >
              {quiz.isPublished ? 'Unpublish' : 'Publish'}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default QuizHeader;
